import { useState } from 'react'
import {
  Menu,
  X,
  Bell,
  Search,
  Settings,
  User,
  LogOut
} from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import ProfileDropdown from './ProfileDropdown'
import NotificationDropdown from './NotificationDropdown'
import SearchBar from '../searchBar/SearchBar'
import talkidaLogo from '../../assets/icons/horizontal-logo-colored.png'

const Header = ({ onMobileMenuToggle, isMobileMenuOpen }) => {
  const { user, logout } = useAuth()
  const [showSearch, setShowSearch] = useState(false)
  const [showNotifications, setShowNotifications] = useState(false)
  const [showProfile, setShowProfile] = useState(false)

  const handleLogout = () => {
    logout()
    window.location.href = '/signin'
  }

  return (
    <header className="bg-secondary-800/50 backdrop-blur-sm border-b border-secondary-700/50 px-6 py-4 relative z-30">
      <div className="flex items-center justify-between">
        {/* Left Section */}
        <div className="flex items-center space-x-4">
          {/* Mobile Menu Button */}
          <button
            onClick={onMobileMenuToggle}
            className="lg:hidden p-2 rounded-lg hover:bg-secondary-700 transition-colors"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-white" />
            ) : (
              <Menu className="w-6 h-6 text-white" />
            )}
          </button>

          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <img
                src={talkidaLogo}
                alt="Talkida Smart Chat Solutions"
                className="h-12 object-contain"
              />
            </div>
          </div>
        </div>

        {/* Center Section - Search */}
        <div className="flex-1 max-w-2xl mx-8 hidden md:block">
          <SearchBar />
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-2">
          {/* Search Button (Mobile) */}
          <button
            onClick={() => setShowSearch(!showSearch)}
            className="md:hidden p-2 rounded-lg hover:bg-secondary-700 transition-colors"
          >
            <Search className="w-5 h-5 text-white" />
          </button>

          {/* Notifications */}
          <div className="relative z-50">
            <button
              onClick={() => setShowNotifications(!showNotifications)}
              className="p-2 rounded-lg hover:bg-secondary-700 transition-colors relative"
            >
              <Bell className="w-5 h-5 text-white" />
              <span className="absolute -top-1 -right-1 w-3 h-3 bg-error-500 rounded-full flex items-center justify-center">
                <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
              </span>
            </button>
            {showNotifications && (
              <NotificationDropdown onClose={() => setShowNotifications(false)} />
            )}
          </div>

          {/* Profile */}
          <div className="relative z-40">
            <button
              onClick={() => setShowProfile(!showProfile)}
              className="flex items-center space-x-2 p-2 rounded-lg hover:bg-secondary-700 transition-colors"
            >
              <div className="w-8 h-8 bg-gradient-to-r from-primary-500 to-accent-500 rounded-full flex items-center justify-center">
                {user?.avatar ? (
                  <img
                    src={user.avatar}
                    alt={user.name}
                    className="w-8 h-8 rounded-full object-cover"
                  />
                ) : (
                  <User className="w-4 h-4 text-white" />
                )}
              </div>
              <span className="text-white font-medium hidden sm:block">
                {user?.name || 'User'}
              </span>
            </button>
            {showProfile && (
              <ProfileDropdown
                user={user}
                onClose={() => setShowProfile(false)}
                onLogout={handleLogout}
              />
            )}
          </div>
        </div>
      </div>

      {/* Mobile Search */}
      {showSearch && (
        <div className="md:hidden mt-4">
          <SearchBar />
        </div>
      )}
    </header>
  )
}

export default Header
